<template>
  <div class="company-supplier">
    <!-- 分组下的供应商 -->
    <div class="content-right">
      <el-form :form="filterForm" label-suffix="：" inline>
        <el-form-item label="供应商">
          <el-input
            v-model.trim="filterForm.supplierName"
            placeholder="请输入供应商名称"
          />
        </el-form-item>
        <el-form-item label="分组">
          <div style="width: 230px">
            <CompanyCategoriesSelect
              v-model="filterForm.categoryId"
              z-index="3000"
            />
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <jczh-table-content
        ref="table"
        :data="listData"
        :option="listOption"
        pagination
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        selection
        table-id="supplierId"
        :selected="selected"
        :selectable="selectable"
        :key-translate="{ supplierId: 'companyId' }"
        @select="handleSelect"
        @selection-change="handleSelectionChange"
        @select-all="handleSelectAll"
      />
    </div>
  </div>
</template>

<script>
import CompanyCategoriesSelect from '@/components/common/SupplierCategorySelect/CompanyCategoriesSelect'

import { getCompanySupplierList } from '@/api/supplier-management/supplier-lib'
import { listFilterMixin } from 'jczh-ui'
import { companyIndustryDict } from '@/dictionary/company'

export default {
  name: 'CompanySupplierFilterTable',

  components: {
    CompanyCategoriesSelect
  },

  mixins: [listFilterMixin],

  props: {
    selected: {
      type: Array,
      default: () => []
    },

    disabledArray: {
      type: Array,
      default: () => []
    },
    isAgency: {
      type: Boolean,
      default: false
    },

    // 采购人公司id
    purchaseCompanyId: {
      type: [String, Number],
      default: ''
    },

    // 是否授权代理机构使用供应商库
    isAllowUseSrm: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      total: 0,
      filterForm: {
        supplierName: '',
        categoryId: undefined
      },
      listData: [],
      listOption: [
        {
          label: '供应商名称',
          prop: 'supplierName',
          minWidth: 150
        },
        {
          label: '联系人',
          prop: 'contactUserName',
          minWidth: 100
        },
        {
          label: '联系方式',
          prop: 'contactUserPhone',
          minWidth: 100
        },
        {
          label: '所属行业',
          prop: 'supplierIndustry',
          minWidth: 100,
          filter: value => companyIndustryDict.translate(value).label || '-'
        }
      ],

      // 分组
      sortSearchText: '',
      currentSort: {},

      // 当前操作的项
      currentRow: {}
    }
  },

  computed: {
    selectable() {
      return row => {
        return this.disabledArray.every(
          item => item.companyId !== row.supplierId
        )
      }
    }
  },

  watch: {
    sortSearchText(val) {
      this.$refs.tree.filter(val)
    }
  },

  created() {
    this.getList()
  },

  methods: {
    /**
     * 过滤分类数据
     */
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    /**
     * 选中供应商分类，获取当前分类
     */
    selectSort(data) {
      this.currentSort = { ...data }
      this.getList()
    },

    /**
     * 获取当前分类下的所有证件
     */
    async getList() {
      this.epitaxy()

      try {
        const params = {
          ...this.filterForm,
          page: this.page,
          size: this.size
        }
        // 代理机构授权使用业主供应商库
        if (this.isAgency && this.isAllowUseSrm) {
          params.companyId = this.purchaseCompanyId
        }
        console.log('params>>>>>>', params)
        const { data } = await getCompanySupplierList(params)
        this.listData = data.records || []
        this.total = data.total || 0
      } catch (err) {
        this.$message.error(err.message || '获取证件列表失败')
      }
    },

    handleSelect(selection, row) {
      this.$emit('select', selection, row)
      this.currentRow = row
    },

    handleSelectionChange(selection) {
      const temp = this.selected.filter(s => {
        return this.listData.findIndex(v => v.supplierId === s.companyId) < 0
      })
      const tempSelection = [...selection]
      temp.forEach(t => {
        if (selection.findIndex(s => s.supplierId === t.companyId) < 0) {
          tempSelection.push(t)
        }
      })
      this.$emit('selectionChange', tempSelection)
    },

    handleSelectAll(selection) {
      this.$emit('selectAll', selection, this.listData)
    },

    clearSelection() {
      this.$refs.table.clearSelection()
    }
  }
}
</script>

<style lang="scss" scoped>
.company-supplier {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .content-left {
    width: 120px;
  }

  .content-right {
    flex-grow: 1;
  }
}

::v-deep .el-table {
  .el-table__fixed {
    height: 100% !important;
  }
}
</style>
